// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pricing_wrapper__ncWy1","left":"Pricing_left__Gktxi","right":"Pricing_right__OoE5_","price":"Pricing_price__eISe6","discount":"Pricing_discount__kCtX3"};